import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/form-controls/Button";
import { useTranslation } from "react-i18next";
declare const bootstrap: any;

interface ModalMessagePreviewProps {
  message: string | null;
  show: boolean;
  onRequestClose: () => void;
}

function ModalMessagePreview({ message, show, onRequestClose }: ModalMessagePreviewProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const [modalInstance, setModalInstance] = useState<any>(null);
  const { t } = useTranslation();

  const isValidJSON = (str: string): boolean => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  const renderMessage = () => {
    const data = message;

    const renderTextWithLinks = (text: string) => {
      const regex = /(https?:\/\/[^\s]+)/g;
      const formattedText = text.replace(regex, (url) => {
        return `<a href="${url}" target="_blank" rel="noreferrer">${url}</a>`;
      });
      return formattedText.replace(
        /{{(.*?)}}/g,
        '<span class="variable">{{$1}}</span>'
      );
    };

    if (!data) {
      return (
        <h4 className="mb-0 text-warning text-nowrap">
          {t("bulk-senders.no-template-data")}
        </h4>
      );
    }

    if (isValidJSON(data)) {
      const template = JSON.parse(data);
      const header = template.find((t: any) => t.type === "HEADER");
      const body = template.find((t: any) => t.type === "BODY");
      const buttons = template.find((t: any) => t.type === "BUTTONS");

      return (
        <div className="row text-center">
          <div className="col-12 d-flex justify-content-center">
            <div className="wrap-android-table mt-2">
              <div
                className="preview-container-RCS-table h-auto"
              >
                <div className="preview-template-RCS-table">
                  {/* HEADER */}
                  {header && header.format === "TEXT" && (
                    <div className="preview-template-header fw-bold text-dark">
                      {header.text}
                    </div>
                  )}
                  {header && header.format === "IMAGE" && (
                    <div className="preview-template-header">
                      {header.image ? (
                        <img
                          src={header.image}
                          alt="Imagen del mensaje"
                          className="preview-template-image img-fluid "
                        />
                      ) : (
                        <span className="badge bg-soft-danger text-danger">
                          Sin imagen
                        </span>
                      )}
                    </div>
                  )}
                  {header && header.format === "VIDEO" && (
                    <div className="preview-template-header">
                      {!header.url && (
                        <div className="preview-template-video-container"></div>
                      )}
                      {header.url && (
                        <video
                          className="preview-template-video-container"
                          controls
                        >
                          <source src={header.url} />
                        </video>
                      )}
                      {!header.url && (
                        <span className="badge bg-soft-danger text-danger">
                          Sin video
                        </span>
                      )}
                      {header.url && (
                        <a href={header.url} target="_blank" rel="noreferrer">
                          <span className="badge bg-soft-primary text-primary">
                            Da clic aquí para visualizar video
                          </span>
                        </a>
                      )}
                    </div>
                  )}

                  {/* BODY */}
                  {body && (
                    <div
                      className="text-dark mb-3"
                      dangerouslySetInnerHTML={{
                        __html: body.text.replace(/\n/g, "<br/>"),
                      }}
                    ></div>
                  )}

                  {/* BUTTONS */}
                  {buttons && (
                    <div>
                      {buttons.buttons.map((btn: any, index: number) => (
                        <div
                          key={index}
                          className={`preview-template-btn text-btn-rcs d-flex align-items-center justify-content-center${
                            index !== 0
                              ? " border-top mt-2 pt-2 divider-btn-rcs"
                              : ""
                          }`}
                        >
                          {btn.type === "URL" && (
                            <>
                              <i className="bi bi-globe-americas"></i>{" "}
                              {btn.text}
                            </>
                          )}
                          {btn.type === "QUICK_REPLY" && (
                            <>
                              <i className="bi bi-send"></i> {btn.text}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row d-flex justify-content-center min-height-100">
          <div className="col-12 d-flex justify-content-center">
            <div
              dangerouslySetInnerHTML={{
                __html: renderTextWithLinks(data),
              }}
            ></div>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (modalRef.current) {
      const instance = new bootstrap.Modal(modalRef.current, {});
      setModalInstance(instance);
    }
  }, []);

  useEffect(() => {
    if (modalInstance) {
      show ? modalInstance.show() : modalInstance.hide();
    }
  }, [show, modalInstance]);

  return (
    <div
      className="modal fade"
      ref={modalRef}
      tabIndex={-1}
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("campaigns.monitoring.message-template")}</h5>
            <button type="button" className="btn-close" onClick={onRequestClose}></button>
          </div>
          <div className="modal-body">{renderMessage()}</div>
          <div className="modal-footer">
            <Button className="btn btn-primary" onClick={onRequestClose}>
              {t("campaigns.monitoring.modal-btn-close")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalMessagePreview;
